interface Props {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Accessible name. */
  label: string;
  /** `success` = Admin `.tg` (40×24, green when on); `navy` = Editor `.tgl` (46×26, navy when on). */
  tone?: 'success' | 'navy';
  disabled?: boolean;
  className?: string;
  id?: string;
  /** id of a visible label; when given it names the switch instead of `label`. */
  labelledBy?: string;
  describedBy?: string;
}

const TRACK = { success: 'h-6 w-10', navy: 'h-[26px] w-[46px]' } as const;
const KNOB = { success: 'h-[18px] w-[18px]', navy: 'h-5 w-5' } as const;
const ON_X = { success: 'translate-x-4', navy: 'translate-x-5' } as const;
const ON_BG = { success: 'bg-success', navy: 'bg-navy' } as const;

/** Toggle switch (`role="switch"`), the design `.tg` / `.tgl`. */
export default function Switch({ checked, onChange, label, tone = 'success', disabled = false, className = '', id, labelledBy, describedBy }: Props) {
  return (
    <button type="button" role="switch" id={id} aria-checked={checked} disabled={disabled}
      {...(labelledBy ? { 'aria-labelledby': labelledBy } : { 'aria-label': label })} aria-describedby={describedBy}
      onClick={() => onChange(!checked)}
      className={`relative inline-block flex-none cursor-pointer rounded-full border-0 p-0 align-middle transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 ${TRACK[tone]} ${checked ? ON_BG[tone] : 'bg-switch-off'} ${className}`}>
      <span aria-hidden="true"
        className={`absolute left-[3px] top-[3px] rounded-full bg-white shadow-knob transition-transform ${KNOB[tone]} ${checked ? ON_X[tone] : 'translate-x-0'}`} />
    </button>
  );
}
